const sectionCardStepInstructions02Css = `
[data-type='section-card-step-instructions-02'] .card-step-instructions-wrapper {
  background-color: var(--background-color, #ffffff);
  color: var(--text-color, #000000);
}

[data-type='section-card-step-instructions-02'] .card-step-instructions-wrapper[data-top-padding='true'] {
  padding-top: 40px;
}

[data-type='section-card-step-instructions-02'] .card-step-instructions-wrapper[data-bottom-padding='true'] {
  padding-bottom: 40px;
}

[data-type='section-card-step-instructions-02'] .card-step-instructions-header:not(:empty) {
  margin-bottom: 24px;
}

[data-type='section-card-step-instructions-02'] .card-step-instructions-header h1,
[data-type='section-card-step-instructions-02'] .card-step-instructions-header h2,
[data-type='section-card-step-instructions-02'] .card-step-instructions-header h3 {
  font-size: 24px;
  line-height: normal;
  margin: 0 0 16px 0 !important;
}

[data-type='section-card-step-instructions-02'] .card-step-instructions-header h1:last-child,
[data-type='section-card-step-instructions-02'] .card-step-instructions-header h2:last-child,
[data-type='section-card-step-instructions-02'] .card-step-instructions-header h3:last-child {
  margin-bottom: 0 !important;
}

[data-type='section-card-step-instructions-02'] .card-step-instructions-header p {
  font-size: 18px;
  margin: 0 0 8px 0 !important;
  line-height: normal;
}

[data-type='section-card-step-instructions-02'] .card-step-instructions-header p:last-child {
  margin-bottom: 0 !important;
}

[data-type='section-card-step-instructions-02'] .card-step-instructions-header figure {
  overflow-x: auto;
  overflow-y: hidden;
}

[data-type='section-card-step-instructions-02'] .card-step-instructions-list {
  --items-gap: 0px;
  display: flex;
  flex-wrap: wrap;
  justify-content: start;
  gap: var(--items-gap);
}

[data-type='section-card-step-instructions-02'] .card-step-instructions-item {
  position: relative;
  --item-basis-desktop: calc(
    (100% - (var(--items-per-row-desktop, 4) - 1) * var(--items-gap)) / var(--items-per-row-desktop, 4)
  );
  --item-basis-mobile: calc(
    (100% - (var(--items-per-row-mobile, 2) - 1) * var(--items-gap)) / var(--items-per-row-mobile, 2)
  );

  flex: 0 0 var(--item-basis-desktop);
  max-width: var(--item-basis-desktop);

  display: flex;
  flex-direction: column;
  align-items: center;

  background-color: var(--odd-background, #14a16c);
  color: var(--odd-text-color, #ffffff);
}

[data-type='section-card-step-instructions-02'] .card-step-instructions-item:nth-child(even) {
  background-color: var(--even-background, #e1e1e1);
  color: var(--even-text-color, #000000);
}

[data-type='section-card-step-instructions-02'] .card-step-instructions-item:nth-child(even) .card-step-instructions-item-title::before {
  border-left: 20px solid var(--odd-background, #14a16c);
}

[data-type='section-card-step-instructions-02'] .card-step-instructions-item:first-child .card-step-instructions-item-title::before {
  display: none;
}

[data-type='section-card-step-instructions-02'] .card-step-instructions-item .card-step-instructions-item-title {
  position: relative;
  font-size: 18px !important;
  line-height: normal;
  font-weight: 700 !important;
  margin: 0 !important;
  padding: 32px 16px;
  width: 100%;
  text-align: center;
  z-index: 2;
}

[data-type='section-card-step-instructions-02'] .card-step-instructions-item .card-step-instructions-item-title::before {
  content: '';
  position: absolute;
  width: 0px;
  height: 0px;
  border-top: 20px solid transparent;
  border-bottom: 20px solid transparent;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  z-index: -1;
  border-left: 20px solid var(--even-background, #e1e1e1);
}

[data-type='section-card-step-instructions-02'] .card-step-instructions-item .card-step-instructions-item-image {
  width: 100%;
  height: var(--item-image-height, 150px);
  max-height: var(--item-image-height, 150px);
}

[data-type='section-card-step-instructions-02'] .card-step-instructions-item .card-step-instructions-item-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

[data-type='section-card-step-instructions-02'] .card-step-instructions-item .card-step-instructions-item-content {
  padding: 24px 16px;
  line-height: normal;
  margin: 0 !important;
}

@container (max-width: 768px) {
  [data-type='section-card-step-instructions-02'] .card-step-instructions-wrapper[data-top-padding='true'] {
    padding-top: 16px;
  }

  [data-type='section-card-step-instructions-02'] .card-step-instructions-wrapper[data-bottom-padding='true'] {
    padding-bottom: 16px;
  }

  [data-type='section-card-step-instructions-02'] .card-step-instructions-header h1,
  [data-type='section-card-step-instructions-02'] .card-step-instructions-header h2,
  [data-type='section-card-step-instructions-02'] .card-step-instructions-header h3 {
    font-size: 20px;
  }

  [data-type='section-card-step-instructions-02'] .card-step-instructions-header p {
    font-size: 14px;
  }

  [data-type='section-card-step-instructions-02'] .card-step-instructions-header figure {
    width: 98% !important;
  }

  [data-type='section-card-step-instructions-02'] .card-step-instructions-item {
    flex-basis: var(--item-basis-mobile);
    max-width: var(--item-basis-mobile);
  }

  [data-type='section-card-step-instructions-02'] .card-step-instructions-item:nth-child(even) .card-step-instructions-item-title::before {
    border-left: 20px solid transparent;
    border-top: 20px solid var(--odd-background, #14a16c);
    border-right: 20px solid transparent;
  }

  [data-type='section-card-step-instructions-02'] .card-step-instructions-item .card-step-instructions-item-title::before {
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    border-left: 20px solid transparent;
    border-right: 20px solid transparent;
    border-top: 20px solid var(--even-background, #e1e1e1);
  }

  [data-type='section-card-step-instructions-02'] .card-step-instructions-item .card-step-instructions-item-image {
    height: auto;
    max-height: none;
  }
}
`;
export default sectionCardStepInstructions02Css;
